import { render } from "./ValidationResultsTabs.vue?vue&type=template&id=731f61d9"
import script from "./ValidationResultsTabs.vue?vue&type=script&lang=js"
export * from "./ValidationResultsTabs.vue?vue&type=script&lang=js"

import "./ValidationResultsTabs.vue?vue&type=style&index=0&id=731f61d9&lang=scss"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTab from 'quasar/src/components/tabs/QTab.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTab});
